export const IC_PERMISSION_COVER =
  "https://res.cloudinary.com/dlzvz9qj8/video/upload/v1792984721/site-permissions-flow_zom1uk.mp4";

export const IC_DESIGN_SYSTEM_COVER =
  "https://res.cloudinary.com/dlzvz9qj8/video/upload/v1792976602/ic-design-system-stack_xmdjgn.mp4";

export const HSP_PLANET_COVER =
  "https://res.cloudinary.com/dlzvz9qj8/video/upload/v1792984001/hsp-app-showcase_wbuuxg.mp4";

export const COLLABSTR_DESIGN_SYSTEM_COVER =
  "https://res.cloudinary.com/dlzvz9qj8/video/upload/v1792978514/condo-not-a-house-collabstr-design-system_psneuv.mp4";

export function isVideoMedia(src) {
  if (!src) return false;
  return /\/video\/upload\//.test(src) || /\.(mp4|webm|mov)(\?|$)/i.test(src);
}
